import { inject } from "fw";
import { createFrom, createFromArray } from "fw-model";

import { Manager } from "./manager";

import { Alarm, AlarmsTripped } from "models/alarms";

@inject
export class AlarmsRepository {
    constructor(private s: Manager) {}

    async list() {
        const res = await this.s.get<Alarm[]>("platform/alarms");
        return createFromArray(Alarm, res.body);
    }

    async getTrippedAlarms() {
        const res = await this.s.get<AlarmsTripped>("platform/alarms/tripped");
        return createFrom(AlarmsTripped, res.body);
    }
}
